import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HistoriqueComponent } from './historique.component';
import { PanelModule } from 'primeng/panel';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { ContenusModule } from '../moderation/contenus/contenus.module';
import { RouterModule } from '@angular/router';
import { DetailsComponent } from './details/details.component';
import {CalendarModule} from 'primeng/calendar';
import { FormsModule } from '@angular/forms';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
import {SliderModule} from 'primeng/slider';

@NgModule({
  declarations: [HistoriqueComponent, DetailsComponent],
  imports: [
    CommonModule,
    PanelModule,
    InputTextModule,
    ButtonModule,
    TableModule,
    DialogModule,
    ContenusModule,
    RouterModule,
    CalendarModule,
    FormsModule,
    MultiSelectModule,
    DropdownModule,
    SliderModule
  ]
})
export class HistoriqueModule { }
